import React, { createContext, useContext, useCallback, useMemo } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const { lang } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const language = lang === "en" ? "English" : "Arabic";
  const fontFamilyStyle = lang === "en" ? "Proxima Soft" : "Aref Ruqaa, serif";

  const switchLanguage = useCallback((newLang) => {
    const currentPath = location.pathname;
    const currentLangPrefix = `/${lang}`;
    let restOfPath = currentPath.startsWith(currentLangPrefix)
      ? currentPath.slice(currentLangPrefix.length)
      : "";
    const hash = location.hash || "";
    navigate(`/${newLang}${restOfPath}${hash}`);
    localStorage.setItem("language", newLang === "en" ? "English" : "Arabic");
  }, [lang, location.pathname, location.hash, navigate]);

  const value = useMemo(
    () => ({ language, fontFamilyStyle, lang, switchLanguage }),
    [language, fontFamilyStyle, lang, switchLanguage]
  );

  return (
    <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};

export default LanguageContext;
